var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('CommonPdfReader',{attrs:{"src":_vm.pdfFileSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }